module.exports = __webpack_public_path__ + "static/img/02.9dd7b68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/companies/hugelshofer/02.jpg
// module id = 389
// module chunks = 1